export const extractDate = (text: string): string | null => {
	if (!text || typeof text !== 'string') {
		return null;
	}

	// Normalize the text by trimming extra whitespace
	const normalizedText = text.trim();

	// Regular expressions to match various date formats, including day of the week
	const datePatterns = [
		// Date ranges (e.g., "May 5th to May 7th, 2025")
		/\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\s+to\s+(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)?\s*\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}\b/i,
		// Day of the week with full date (e.g., "Monday, May 26th")
		/\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
		// Full dates with year (e.g., "May 26, 2025")
		/\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s+\d{4}\b/i,
		// Dates with ordinals (e.g., "June 30th")
		/\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
		// Month and year formats (e.g., "March 2025")
		/\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{4}\b/i,
	];

	// Loop through patterns and try to find a match
	for (const pattern of datePatterns) {
		const match = normalizedText.match(pattern);
		if (match) {
			return match[0]; // Return the matched date or date range
		}
	}

	// If no date is found, return null
	return null;
};
